exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".StackTraceView___26MGM {\n  padding: 0.25rem;\n}\n\n.CallSite___2R0dJ, .BuiltInCallSite___2URhX {\n  display: flex;\n  padding-left: 1rem;\n  white-space-collapse: preserve;\n}\n\n.IgnoredCallSite___11QXz, .BuiltInCallSite___2URhX {\n  display: none;\n}\n\n.CallSite___2R0dJ + .BuiltInCallSite___2URhX {\n  display: block;\n}\n\n.Link___1RwG9 {\n  color: var(--color-link);\n  white-space: pre;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  cursor: pointer;\n  border-radius: 0.125rem;\n}\n\n.Link___1RwG9:hover {\n  background-color: var(--color-background-hover);\n}\n\n.ElementBadges___1rcvf {\n  margin-left: 0.25rem;\n}\n\n", ""]);

// exports
exports.locals = {
	"StackTraceView": "StackTraceView___26MGM",
	"CallSite": "CallSite___2R0dJ",
	"BuiltInCallSite": "BuiltInCallSite___2URhX",
	"IgnoredCallSite": "IgnoredCallSite___11QXz",
	"Link": "Link___1RwG9",
	"ElementBadges": "ElementBadges___1rcvf"
};